import client from './inventory-request';
import { getStoreActorId } from '../hooks/useStoreScope';

/**
 * Requisition consolidation — stock-ledger-service
 * POST /inventory/stock/consolidations/generate/
 * GET  /inventory/stock/consolidations/{id}/
 * POST /inventory/stock/consolidations/{id}/create-po/
 */

// API: POST /inventory/stock/consolidations/generate/
export function generateConsolidation(body = {}) {
  const payload = {
    requisition_status_in: ['SUBMITTED', 'APPROVED'],
    ...body,
  };
  const actor = body.created_by || getStoreActorId();
  if (actor && !payload.created_by) payload.created_by = actor;
  return client.post('/inventory/stock/consolidations/generate/', payload);
}

// API: GET /inventory/stock/consolidations/{id}/
export function getConsolidation(id) {
  return client.get(`/inventory/stock/consolidations/${id}/`);
}

// API: POST /inventory/stock/consolidations/{id}/create-po/
export function createPoFromConsolidation(id, body = {}) {
  return client.post(`/inventory/stock/consolidations/${id}/create-po/`, body);
}
